// Land for the dotted globe that MediaGlobe.js shows when WebGL is unavailable, as dot rows:
// each entry is a latitude and the longitude ranges [from, to, from, to, ...] that are land
// along it. Rows are LAND_ROW_STEP degrees apart. Traced by hand from simplified coastlines, so it is only
// accurate to a couple of degrees, which is all a dotted globe needs.
export const LAND_ROW_STEP = 2.2;

export const LAND_ROWS = [
  [-88.9, [-180, 179.8]],
  [-86.7, [-180, 179.8]],
  [-84.5, [-180, 179.8]],
  [-82.3, [-180, 179.8]],
  [-80.1, [-180, 179.8]],
  [-77.9, [-180, -38.2, -34.5, 179.8]],
  [-75.7, [-146.8, -57.2, -29, 176.5]],
  [-73.5, [-104.8, -66.2, -22.2, 172.5]],
  [-71.3, [-67.2, -62.8, -11.2, 163.8]],
  [-69.1, [-66, -62.2, 38.2, 73.5, 77.2, 152.8]],
  [-66.9, [-64.8, -61, 88.2, 135.2]],
  [-64.7, [-61.5, -58.8]],
  [-53.7, [-71.8, -67.2]],
  [-51.5, [-74.2, -69.2]],
  [-49.3, [-75.5, -67.5]],
  [-47.1, [-75.5, -66.5]],
  [-44.9, [-74.5, -65, 167.2, 170.8]],
  [-42.7, [-74, -63.8, 145.5, 147.8, 171, 173.2]],
  [-40.5, [-73.5, -62.2, 174.2, 176.2]],
  [-38.3, [-73.2, -59.5, 141.5, 147.2, 174.8, 178.2]],
  [-36.1, [-72.8, -57, 139.8, 150, 173.8, 174.8]],
  [-33.9, [-71.8, -54, 18.5, 25.8, 115.2, 121.8, 135, 137.2, 137.8, 151.2]],
  [-31.7, [-71.2, -52, 17.8, 29, 115.8, 129.8, 131.5, 152.5]],
  [-29.5, [-71, -49.8, 17, 31.5, 115.2, 153.2]],
  [-27.3, [-70.8, -48.8, 15.8, 32.5, 114, 152.8]],
  [-25.1, [-70.5, -47.5, 15, 33.8, 45, 47, 113.8, 151.5]],
  [-22.9, [-70.2, -42, 14.5, 35.2, 43.8, 47.8, 114, 150]],
  [-20.7, [-70, -40.8, 14, 35, 43.8, 48.2, 116.8, 148.5]],
  [-18.5, [-70.2, -39.5, 13.5, 36.2, 44.2, 49, 122, 146.2]],
  [-16.3, [-73, -39, 12.2, 39.5, 45.5, 50, 123.8, 137.5, 141.2, 145.2]],
  [-14.1, [-75.5, -38.8, 13, 40.2, 47.8, 50, 126.5, 127, 130, 135.8, 141.8, 143.5]],
  [-11.9, [-77, -37.8, 13.5, 40.2, 132, 134.5, 142, 142.8]],
  [-9.7, [-78, -36.2, 13.2, 40, 148.2, 149.8]],
  [-7.5, [-79.2, -35, 13, 39.5, 107, 113.5, 138.2, 147.8]],
  [-5.3, [-81, -36, 12.2, 39.5, 104, 105.8, 119.5, 120.2, 137.2, 145.8]],
  [
    -3.1,
    [
      -80, -41, 10.8, 40, 102, 105.5, 111, 116.2, 119, 120.8, 121.5, 122.8, 132.2, 135.2, 136, 142.2
    ],
  ],
  [-0.9, [-80.8, -49, 9.5, 42, 100.5, 104, 109.5, 116.8, 120.2, 123.2, 131.8, 133.8]],
  [1.3, [-79.2, -50, 9.5, 44.2, 99.2, 101.8, 103.5, 103.5, 109.2, 117.8]],
  [3.5, [-77.2, -51, 9.8, 47.2, 97, 99, 101.2, 103.5, 112.8, 117.8]],
  [5.7, [-77.2, -55, -9.8, 0.2, 5.2, 48.8, 100.2, 102.2, 115.8, 118.5, 125.5, 125.5]],
  [7.9, [-82, -80.2, -77.8, -59.8, -12.5, 50, 80, 81.5, 98.8, 100.2, 123, 126.2]],
  [10.1, [-85, -83.2, -75.8, -62.5, -14, 50.8, 76.2, 79, 98.8, 99.2, 104.2, 106.2]],
  [12.3, [-87, -83.8, -71.8, -71.8, -16.5, 43, 75.2, 80, 98.8, 99.8, 102, 109]],
  [14.5, [-92, -83.5, -17.2, 40.5, 43, 49, 74.2, 80, 98.2, 108.8, 120.5, 123.5]],
  [16.7, [-99, -88.2, -16.2, 39, 42.8, 53.5, 73.5, 82.2, 94.2, 96, 96.8, 107.2, 120, 122.2]],
  [
    18.9,
    [
      -104, -95.8, -91.8, -87.5, -73.8, -69, -16, 37.8, 40.8, 57, 73, 84.8, 93.8, 105.8, 108.8,
      110.5
    ],
  ],
  [
    21.1,
    [
      -105.2, -97.2, -89.5, -87, -78.2, -76.5, -16.8, 36.5, 39.5, 59, 70.5, 86.8, 92.2, 107.2,
      108.8, 110.2
    ],
  ],
  [23.3, [-110.2, -110.2, -106.5, -97.8, -16, 35.8, 38.5, 58.8, 68.8, 116.5, 120.2, 121.5]],
  [25.5, [-112.5, -111.2, -108.8, -97.5, -81, -80.5, -14.8, 34.8, 37, 51.2, 55.5, 56.2, 59.2, 119]],
  [27.7, [-114, -112.8, -110.5, -97.5, -82.5, -80.5, -13, 33.5, 36, 48.8, 52.2, 120.8]],
  [29.9, [-115.5, -113.8, -112.2, -89.2, -85.8, -84.5, -83.8, -81.2, -10, 48.2, 49.8, 121.8]],
  [32.1, [-116.8, -81, -9.5, 15.5, 20.8, 24, 35, 121.2, 130, 131.5]],
  [34.3, [-119.8, -77.2, -6.8, 10, 35.8, 120.2, 131.5, 136.8]],
  [
    36.5,
    [
      -121.8, -76, -6.2, -4.8, 1.2, 10.8, 23, 23, 32, 32, 36.2, 121, 126.8, 129.2, 136.5, 140.8
    ],
  ],
  [
    38.7,
    [
      -123, -75, -9.2, -0.5, 15.8, 16.5, 21, 23.2, 26.8, 49, 54, 117.8, 125.5, 128, 139.5, 141.2
    ],
  ],
  [40.9, [-124.2, -73.2, -8.5, 1, 8.2, 9.8, 14, 17.2, 19.5, 49.8, 53, 129.5, 140.2, 141.2]],
  [43.1, [-124.5, -70.8, -8.8, 3.8, 10.8, 13.8, 17.2, 27.8, 41, 47.2, 51.8, 133.5, 140.5, 145.2]],
  [45.3, [-124, -62.5, -1, 12.2, 14, 29.8, 33.5, 35, 36.8, 47.2, 53.2, 136.8, 141.8, 141.8]],
  [47.5, [-124.2, -70.5, -69.8, -65.5, -56, -53, -3, 139, 142, 143.2]],
  [49.7, [-125.8, -67.5, -58.2, -55.8, 0.8, 140.2, 142, 144]],
  [51.9, [-128.8, -81.2, -78.8, -56.5, -10, -7.5, -5, 1, 4.2, 140.8, 142.2, 143, 156.5, 157.5]],
  [
    54.1,
    [
      -130.2, -82.5, -78.8, -57.8, -9.8, -5.8, -3.2, -0.2, 8.8, 12.8, 15.2, 138, 142.5, 142.8, 156,
      159.5
    ],
  ],
  [
    56.3,
    [
      -162.2, -157.2, -132.8, -89.5, -77.8, -61.5, -5.5, -2.5, 8.2, 10.5, 12.8, 16, 21.2, 136.8,
      156, 163
    ],
  ],
  [
    58.5,
    [
      -159.8, -153, -137, -94, -78, -68.2, -67.8, -62.8, -5, -3.2, 6.2, 8.8, 11.5, 17.2, 23.5,
      140.8, 156.5, 163
    ],
  ],
  [60.7, [-164.5, -150.5, -147, -94.2, -77.5, -70, -47, -43.5, 5.2, 18, 21.5, 155.8, 156.5, 171.5]],
  [62.9, [-164, -91.5, -70.2, -65.5, -50.8, -41.8, 8, 18.2, 21.8, 177.8]],
  [
    65.1,
    [
      -180, -171.2, -166.8, -88.2, -86.8, -83.8, -76.5, -63.8, -52.2, -39.2, -24, -13.8, 11.8, 21.5,
      25.2, 179.8
    ],
  ],
  [67.3, [-180, -175.5, -163.8, -81.8, -73, -63, -53.5, -30.2, 13.8, 179.8]],
  [
    69.5,
    [
      -162.8, -139.2, -133.8, -124.5, -115.5, -103.8, -86.2, -82.8, -80, -67.2, -54.2, -23.5, 18.8,
      31, 59.8, 66.2, 66.8, 158.8, 168, 172.5
    ],
  ],
  [71.7, [-124.2, -121, -117.8, -104.5, -88.8, -73.2, -55.5, -21.8, 52.2, 58.5, 68.2, 145.8]],
  [73.9, [-120.8, -119.5, -57.2, -21.2, 57, 62.8, 82.5, 112.8]],
  [76.1, [-117, -104.2, -93, -89.8, -63.8, -19.8, 62.8, 67.2, 100.5, 107.5]],
  [78.3, [-93.5, -75.5, -71, -18.8, 11.8, 23.2]],
  [80.5, [-90.5, -67.8, -64.8, -14.8]],
  [82.7, [-72.8, -67.8, -48.2, -26]],
];
